<template>
  <div id="examplePage">
    <Scanner id="barScannerZone" v-if="barCodeScannerActive" @found="receiveResultBarCode($event)"></Scanner>
    <QrScanner id="qrScannerZone" v-if="qrCodeScannerActive" @found="receiveResultQrCode($event)" :stopOnScanned="true"></QrScanner>
    <div>
      Codes lus :
      <div v-for="foundCode of foundCodes" :key="foundCode.code">
        {{foundCode.code}} ({{foundCode.type}}) <br/>
      </div>
    </div>
    <nav>
      <div v-show="!barCodeScannerActive">
        <button @click="startBarCode">Lire barre</button>
      </div>

      <div v-show="barCodeScannerActive">
        <button @click="stopBarCode">Stop barre</button>
      </div>

      <div v-show="!qrCodeScannerActive">
        <button @click="startQrCode">Lire QR</button>
      </div>

      <div v-show="qrCodeScannerActive">
        <button @click="stopQrCode">Stop QR</button>
      </div>
    </nav>
    <p>
      <router-link :to="{ path: 'private' }">Accès test SSO</router-link><br>
      <router-link :to="{ path: 'notification' }">Accès test notification</router-link><br>
      <router-link :to="{ path: 'pdf' }">Accès test pdf</router-link>
    </p>
  </div>
</template>

<script>
import Scanner from './Scanner.vue'
import QrScanner from './QrScanner.vue'

export default {
  name: 'ExamplePage',
  components: {
    Scanner,
    QrScanner
  },

  data: () => ({
    barCodeScannerActive: false,
    qrCodeScannerActive: false,
    foundCodes: []
  }),

  props: {
  },

  methods: {
    startBarCode() {
      this.barCodeScannerActive = true;
    },
    stopBarCode() {
      this.barCodeScannerActive = false;
    },
    receiveResultBarCode(code) {
      this.foundCodes.push(code);
      this.barCodeScannerActive = false;
    },
    startQrCode() {
      this.qrCodeScannerActive = true;
    },
    stopQrCode() {
      this.qrCodeScannerActive = false;
    },
    receiveResultQrCode(event) {
      this.foundCodes.push({type: 'QRCode', code: event});
      this.qrCodeScannerActive = false;
    }
  }
}
</script>

<style>
    #qrScannerZone {
        max-height: 200px;
        overflow: hidden;
    }
</style>